export default {
  title: 'Choose the package that',
  title_light: ' suits you best!',
  description:
    'Save time and money by having access to 100+ customized legal documents and unlimited phone consultations with specialized attorneys'
};
